import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "@styles/readers.scss";
import { Div, Icon } from "@components/Generics.react";
import Accordion from "@components/Accordion.react";

export default function FAQReader(props) {
    const { deck, closeDeck, recordAttempt } = props;
    const { t } = useTranslation("common");

    //---------------------------------------------------------------------------
    // Completion Tracking
    //---------------------------------------------------------------------------
    useEffect(() => {
        recordAttempt({
            viewedPercentage: 100,
            completion: true,
            pointsDelta: 0,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let panels = deck?.content.map((item) => {
        return {
            title: <Div small>{`${t("deck.faq.qAbbr")} ${item.title}`}</Div>,
            content: <Div>{item.description}</Div>,
        };
    });

    return (
        <Div
            fluid
            fullht
            noOverflow
            rounded
            left-align
            priText
            slightShadow
            className="faq-reader"
        >
            <Accordion panels={panels}></Accordion>
            <Div className="close-icon" onClick={closeDeck}>
                {t("deck.close")} <Icon name="close" inline fitted />
            </Div>
        </Div>
    );
}
